import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from './layouts/full/full-layout.component';

import {ContentLayoutComponent} from './layouts/content/content-layout.component';
import {CONTENT_ROUTES} from './shared/routes/content-layout.routes';
import {Full_ROUTES} from './shared/routes/full-layout.routes';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/redirect/check',
    pathMatch: 'full',
  },
  // {
  //   path: 'servizi/tesseramento',
  //   redirectTo: 'servizi/tesseramento',
  //   pathMatch: 'full',
  // },
  { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES },
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
  { path: '**', redirectTo: '/redirect/check' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    appRoutes,
    {
      enableTracing: false, // <-- debugging purposes only
    }
  )],
  exports: [RouterModule]
})

export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts